import * as React from 'react';
/**
 * @internal
 */
const AnnounceContext = React.createContext(undefined);
export const AnnounceProvider = AnnounceContext.Provider;
/**
 * Returns a function that can be used to announce messages to screen readers.
 */
export function useAnnounce() {
  var _React_useContext;
  return (_React_useContext = React.useContext(AnnounceContext)) !== null && _React_useContext !== void 0 ? _React_useContext : {
    announce: () => undefined
  };
}